import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39543cf6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=39543cf6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39543cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39543cf6')) {
      api.createRecord('39543cf6', component.options)
    } else {
      api.reload('39543cf6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39543cf6&scoped=true", function () {
      api.rerender('39543cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/employeeCompanyTag/index.vue"
export default component.exports